import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

export const PublicRoute = ({ children, ...routeProps }: RouteProps) => {
	return <Route {...routeProps}>{children}</Route>;
};
